import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HandAccesibility } from 'src/app/core/helpers/hand-accesibility/hand-accesibility';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false
})
export class MainLayoutComponent implements OnInit {

  public dropActive = false;
  public dropActiveAside = false;
  public maxHight: any;
  public ifClickShadow = false;
  @Output() toggleMenuPQRS: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private title: Title) { }

  ngOnInit() {

  }
  ngAfterViewInit(){
    let objectsA = HandAccesibility.DomObject.filter(a => a.front==='home');
    let i: any;
    let j: any;
    let k: any;

    for (i = 1; i <= objectsA.length; i++) {
        let objDom = document.getElementById(objectsA[i-1].object);
        if (objDom!=null) objDom.setAttribute("tabindex",i);
        k=i;
    }
    let btnInformacionImportant = document.getElementById(objectsA[0].object);
    if (btnInformacionImportant) btnInformacionImportant.focus();

  }

  dropDown(e) {
    this.dropActive = e;
    this.maxHight = document.getElementById('body').clientHeight;
  }

  dropDownAside(e) {
    this.dropActiveAside = e;
    let objDom = document.getElementById('body');
    if (objDom!=null) this.maxHight = objDom.clientHeight;
  }

  clickShadow() {
    this.dropActiveAside = false;
    this.ifClickShadow = !this.ifClickShadow;

  }

  @HostListener('window:click',[])
  sendtoggleMenuPQRS(event?: any){
    this.toggleMenuPQRS.emit(true);
  }

}
